import type { ReactNode } from 'react';
import type { PromotionContent } from '@wconcept/wconcept-common/models/renewal/promotion';
import { toPromotionModuleVisualTokens } from '@utils/promotionContentVisual';
import ModuleAnchorWrapper from '../components/ModuleAnchorWrapper';
import TopBuyerModule from '../PromotionModules/TopBuyerModule';
import { isInDisplayTimeRange } from './displayTimeChecker';
import { ModuleErrorBoundary } from './ErrorBoundary';
import { isTopBuyerModule } from './typeGuards';

interface RenderTopBuyerModuleParams {
  readonly content: PromotionContent;
  readonly isMobile: boolean;
  readonly registerModule?: (
    contentId: string,
    element: HTMLElement | null
  ) => void;
  readonly isLogin?: boolean;
}

export const renderTopBuyerModule = ({
  content,
  isMobile,
  registerModule,
  isLogin = false,
}: RenderTopBuyerModuleParams): ReactNode => {
  if (content.displayStatus !== 'USE') return null;

  const topBuyerModules = content.modules?.filter(isTopBuyerModule);
  const filteredTopBuyerModules = topBuyerModules?.filter(
    module =>
      isInDisplayTimeRange(module.eventStartDate, module.eventEndDate) &&
      module.displayStatus !== 'DELETE'
  );
  if (!filteredTopBuyerModules?.length) return null;

  const visualTokens = toPromotionModuleVisualTokens(content, {
    mask: 'full',
  });

  return (
    <ModuleErrorBoundary key={content.contentId}>
      <ModuleAnchorWrapper
        order={content.displayOrder}
        className="corner-purchase-king"
        id={`section${content.displayOrder}`}
        key={content.contentId}
        registerModule={registerModule}
        contentId={content.contentId.toString()}
        isDesktop={!isMobile}
      >
        {filteredTopBuyerModules.map(module => (
          <TopBuyerModule
            key={module.moduleId}
            bgType={content.colorType?.toLowerCase() || ''}
            visualTokens={visualTokens}
            module={module}
            promotionId={content.promotionId}
            isDesktop={!isMobile}
            isLogin={isLogin}
          />
        ))}
      </ModuleAnchorWrapper>
    </ModuleErrorBoundary>
  );
};
